import { StyleSheet } from "aphrodite/no-important";
import { colour } from "../style/base-theme";

export const styles = StyleSheet.create({
  endWrapper: {
    display: "flex",
    position: "relative",
    alignItems: "flex-start",
    justifyContent: "center",
    paddingBottom: 15
  },
  leftSide: {
    flex: 1,
    ":after": {
      display: "block",
      position: "absolute",
      content: '""',
      top: 0,
      left: 10,
      height: 16,
      width: 16,
      background: "#ffffff",
      border: `1px solid ${colour.grey[400]}`,
      borderRadius: "50%"
    }
  },
  rightSide: {
    flex: 4,
    textAlign: "center",
    color: colour.grey[400],
    fontSize: 16
  }
});
